export function formatSearchPath(path: string | string[]) {
    if (!Array.isArray(path)) {
        return path;
    }

    const formattedSearchPath = path.slice(1);

    return formattedSearchPath
        .map((path) => {
            return path.replace(/-/, ' ');
        })
        .reverse()
        .join(', ');
}
